/* Auto-generated from sk-article-lovebrand-override.liquid */

  (function() {
    if (!document.body.classList.contains('template-article')) return;
    function init() {
      // Detect author name and set data-author-first on containers
      var authorBoxes = document.querySelectorAll('.sidebar-author, .mobile-author-box');
      authorBoxes.forEach(function(box) {
        if (box.hasAttribute('data-author-first')) return;
        var nameEl = box.querySelector('.sidebar-author__name, [class*="author__name"], [class*="author-name"]');
        var name = (nameEl && nameEl.textContent || '').trim();
        var first = name.split(/\s+/)[0];
        if (first) box.setAttribute('data-author-first', first);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
